<template>
<div>
  <normal-page :reportInfo="reportInfo" :currentPage="currentPage" v-if="reportInfo.language==='English'">
    <div style="over-flow:hidden;height:24.6rem;">
    <div style="text-align:center;" id="signatureTable" >
      <table style="border-collapse:collapse;width:100%;">
        <tr>
          <td style="border:1px solid #000;border-left:none;width:20%;height:2rem;">
            <p style="font-size:0.5rem;font-family:Times New Roman;">Name of item</p>
          </td>
          <td style="border:1px solid #000;font-family:SimSun;font-size:0.7rem;width:25%;">{{reportInfo.sampleName}}</td>
          <td style="border:1px solid #000;border-left:none;width:20%;">
            <p style="font-size:0.5rem;font-family:Times New Roman;">Contract No.</p>
          </td>
          <td style="border:1px solid #000;border-right:none;font-family:SimSun;font-size:0.7rem;width:35%;">{{reportInfo.project_display_no}}</td>
        </tr>
        <tr>
          <td style="border:1px solid #000;border-left:none;width:3rem;height:2rem;">
            <p style="font-size:0.5rem;font-family:Times New Roman;">Item Qty.</p>
          </td>
          <td style="border:1px solid #000;font-family:SimSun;font-size:0.7rem;">{{reportInfo.sampleAmount}}</td>
          <td style="border:1px solid #000;border-left:none;">
            <p style="font-size:0.5rem;font-family:Times New Roman;">Location of test</p>
          </td>
          <td style="border:1px solid #000;border-right:none;font-family:SimSun;font-size:0.7rem;">{{reportInfo.testLocation}}</td>
        </tr>
        <tr>
          <td style="border:1px solid #000;border-left:none;width:3rem;height:2rem;">
            <p style="font-size:0.5rem;font-family:Times New Roman;">Date of receipt</p>
          </td>
          <td style="border:1px solid #000;font-family:SimSun;font-size:0.7rem;">{{reportInfo.receiptDate}}</td>
          <td style="border:1px solid #000;border-left:none;">
            <p style="font-size:0.5rem;font-family:Times New Roman;">Date of test</p>
          </td>
          <td style="border:1px solid #000;border-right:none;font-family:SimSun;font-size:0.7rem;">{{reportInfo.testDate}}</td>
        </tr>
        <tr>
          <td style="border:1px solid #000;border-left:none;width:3rem;height:2rem;">
            <p
              style="font-size:0.5rem;font-family:Times New Roman;"
            >Characterization,</p>
            <p
              style="font-size:0.5rem;font-family:Times New Roman;"
            >condition of item</p>
          </td>
          <td style="border:1px solid #000;border-right:none;font-family:SimSun;font-size:0.7rem;" colspan="3">{{reportInfo.sampleInfo}}</td>
        </tr>
        <tr>
          <td style="border:1px solid #000;border-left:none;width:3rem;height:2rem;">
            <p style="font-size:0.5rem;font-family:Times New Roman;">Test standard</p>
          </td>
          <td style="border:1px solid #000;border-right:none;font-family:SimSun;font-size:0.6rem;text-align:left;padding-left:0.3rem;" colspan="3">
            <p v-for="(ele,index) in reportInfo.standardList" :key="index+'standard'">{{(ele.prefix===undefined?'':ele.prefix)+ele.standard_prefix+' '+ele.standard_no+'-'+ele.standard_year+'《'+ele.standard_name_ch+'》'}}</p>
          </td>
        </tr>
        <tr v-if="reportInfo.testItems">
          <td style="border:1px solid #000;border-left:none;height:2rem;">
            <p style="font-size:0.5rem;font-family:Times New Roman;">Test items</p>
          </td>
          <td style="border:1px solid #000;border-right:none;font-family:SimSun;font-size:0.6rem;text-align:left;padding-left:0.3rem;" colspan="3">
            {{reportInfo.testItems}}
          </td>
        </tr>
        <tr v-if="reportInfo.testDevices">
          <td style="border:1px solid #000;border-left:none;height:2rem;">
            <p style="font-size:0.5rem;font-family:Times New Roman;">Test devices</p>
          </td>
          <td style="border:1px solid #000;border-right:none;font-family:SimSun;font-size:0.6rem;text-align:left;padding-left:0.3rem;" colspan="3">
            {{reportInfo.testDevices}}
          </td>
        </tr>
        <tr v-if="reportInfo.testConclusion">
          <td style="border:1px solid #000;border-left:none;height:2rem;">
            <p style="font-size:0.5rem;font-family:Times New Roman;">Test conclusion</p>
          </td>
          <td style="border:1px solid #000;border-right:none;font-family:SimSun;font-size:0.6rem;text-align:left;padding-left:0.3rem;" colspan="3">
            {{reportInfo.testConclusion}}
          </td>
        </tr>
      </table>
    </div>
    <div style="text-align:justify;margin-top:0.7rem;">
      <slot></slot>
    </div>
    </div>
    <div style="border-top:1px solid #000;text-align:center;margin-top:0.7rem;" slot="signature">
      <table class="sign-table">
        <tr style="">
          <td style="width:4rem;">
            
            <p
              style="font-size:0.5rem;font-family:Times New Roman;line-height:0.6rem;height:0pt;"
            >Authorizer</p>
          </td>
          <td style="border-bottom:1px solid #000;width:98pt;"><div style="width:100%;text-align:center;margin-bottom:-8pt;"><img style="width:3rem;" :src="signature.authorizer.sUrl" /></div></td>
          <td style="width:4rem;">
           
            <p
              style="font-size:0.5rem;font-family:Times New Roman;line-height:0.6rem;height:0pt;"
            >Verifier</p>
          </td>
          <td style="border-bottom:1px solid #000;width:98pt;"><div style="width:100%;text-align:center;margin-bottom:-8pt;"><img style="width:3rem;" :src="signature.verifier.sUrl" /></div></td>
          <td style="width:4rem;">
           
            <p
              style="font-size:0.5rem;font-family:Times New Roman;line-height:0.6rem;height:0pt;"
            >Inspector</p>
          </td>
          <td style="border-bottom:1px solid #000;width:98pt;"><div style="width:100%;text-align:center;margin-bottom:-8pt;"><img style="width:3rem;" :src="signature.inspector.sUrl" /></div></td>
        </tr>
        <tr style="">
          <td style="">
            
            <p
              style="font-size:0.5rem;font-family:Times New Roman;line-height:0.6rem;height:0pt;"
            >Name</p>
          </td>
          <td style="border-bottom:1px solid #000;width:98pt;font-family:SimSun;font-size:11pt;padding-top:8pt;">{{signature.authorizer.sName}}</td>
          <td style="">
            
            <p
              style="font-size:0.5rem;font-family:Times New Roman;line-height:0.6rem;height:0pt;"
            >Name</p>
          </td>
          <td style="border-bottom:1px solid #000;width:98pt;font-family:SimSun;font-size:11pt;padding-top:8pt;">{{signature.verifier.sName}}</td>
          <td style="">
            
            <p
              style="font-size:0.5rem;font-family:Times New Roman;line-height:0.6rem;height:0pt;"
            >Name</p>
          </td>
          <td style="border-bottom:1px solid #000;width:98pt;font-family:SimSun;font-size:11pt;padding-top:8pt;">{{signature.inspector.sName}}</td>
        </tr>
        <tr style="">
          <td style="">
           
            <p
              style="font-size:0.5rem;font-family:Times New Roman;line-height:0.6rem;height:0pt;"
            >Date of Issue</p>
          </td>
          <td style="border-bottom:1px solid #000;width:98pt;font-family:SimSun;font-size:0.6rem;padding-top:8pt;">{{signature.authorizer.sDate}}</td>
          <td style="">
         
            <p
              style="font-size:0.5rem;font-family:Times New Roman;line-height:0.6rem;height:0pt;"
            >Date</p>
          </td>
          <td style="border-bottom:1px solid #000;width:98pt;font-family:SimSun;font-size:0.6rem;padding-top:8pt;">{{signature.verifier.sDate}}</td>
          <td style="">
          
            <p
              style="font-size:0.5rem;font-family:Times New Roman;line-height:0.6rem;height:0pt;"
            >Date</p>
          </td>
          <td style="border-bottom:1px solid #000;width:98pt;font-family:SimSun;font-size:0.6rem;padding-top:8pt;">{{signature.inspector.sDate}}</td>
        </tr>
      </table>
    </div>
  </normal-page>
  <normal-page :reportInfo="reportInfo" :currentPage="currentPage" v-else>
    <div style="over-flow:hidden;height:23rem;">
    <div style="text-align:center;" id="signatureTable" >
      <table style="border-collapse:collapse;width:100%;">
        <tr>
          <td style="border:1px solid #000;border-left:none;width:20%;height:1.6rem;">
            <p style="font-size:0.6rem;font-family:KaiTi;">样品名称</p>
            <p style="font-size:0.5rem;font-family:Times New Roman;">Name of item</p>
          </td>
          <td style="border:1px solid #000;font-family:SimSun;font-size:0.7rem;width:25%;">{{reportInfo.sampleName}}</td>
          <td style="border:1px solid #000;border-left:none;width:20%;">
            <p style="font-size:0.6rem;font-family:KaiTi;">委托单编号</p>
            <p style="font-size:0.5rem;font-family:Times New Roman;">Contract No.</p>
          </td>
          <td style="border:1px solid #000;border-right:none;font-family:SimSun;font-size:0.7rem;width:35%;">{{reportInfo.project_display_no}}</td>
        </tr>
        <tr>
          <td style="border:1px solid #000;border-left:none;width:3rem;height:1.6rem;">
            <p style="font-size:0.6rem;font-family:KaiTi;">样品数量</p>
            <p style="font-size:0.5rem;font-family:Times New Roman;">Item Qty.</p>
          </td>
          <td style="border:1px solid #000;font-family:SimSun;font-size:0.7rem;">{{reportInfo.sampleAmount}}</td>
          <td style="border:1px solid #000;border-left:none;">
            <p style="font-size:0.6rem;font-family:KaiTi;">检测地点</p>
            <p style="font-size:0.5rem;font-family:Times New Roman;">Location of test</p>
          </td>
          <td style="border:1px solid #000;border-right:none;font-family:SimSun;font-size:0.7rem;">{{reportInfo.testLocation}}</td>
        </tr>
        <tr>
          <td style="border:1px solid #000;border-left:none;width:3rem;height:1.6rem;">
            <p style="font-size:0.6rem;font-family:KaiTi;">委托日期</p>
            <p style="font-size:0.5rem;font-family:Times New Roman;">Date of receipt</p>
          </td>
          <td style="border:1px solid #000;font-family:SimSun;font-size:0.7rem;">{{reportInfo.receiptDate}}</td>
          <td style="border:1px solid #000;border-left:none;">
            <p style="font-size:0.6rem;font-family:KaiTi;">检测日期</p>
            <p style="font-size:0.5rem;font-family:Times New Roman;">Date of test</p>
          </td>
          <td style="border:1px solid #000;border-right:none;font-family:SimSun;font-size:0.7rem;">{{reportInfo.testDate}}</td>
        </tr>
        <tr>
          <td style="border:1px solid #000;border-left:none;width:3rem;height:1.6rem;">
            <p style="font-size:0.6rem;font-family:KaiTi;">样品特性、状态</p>
            <p
              style="font-size:0.5rem;font-family:Times New Roman;"
            >Characterization,</p>
            <p
              style="font-size:0.5rem;font-family:Times New Roman;"
            >condition of item</p>
          </td>
          <td style="border:1px solid #000;border-right:none;font-family:SimSun;font-size:0.7rem;" colspan="3">{{reportInfo.sampleInfo}}</td>
        </tr>
        <tr>
          <td style="border:1px solid #000;border-left:none;width:3rem;height:1.6rem;">
            <p style="font-size:0.6rem;font-family:KaiTi;">检测依据</p>
            <p style="font-size:0.5rem;font-family:Times New Roman;">Test standard</p>
          </td>
          <td style="border:1px solid #000;border-right:none;font-family:SimSun;font-size:0.6rem;text-align:left;padding-left:0.3rem;" colspan="3">
            <p v-for="(ele,index) in reportInfo.standardList" :key="index+'standard'">{{(ele.prefix===undefined?'':ele.prefix)+ele.standard_prefix+' '+ele.standard_no+'-'+ele.standard_year+'《'+ele.standard_name_ch+'》'}}</p>
          </td>
        </tr>
        <tr v-if="reportInfo.testItems">
          <td style="border:1px solid #000;border-left:none;height:1.6rem;">
            <p style="font-size:0.6rem;font-family:KaiTi;">检测项目</p>
            <p style="font-size:0.5rem;font-family:Times New Roman;">Test items</p>
          </td>
          <td style="border:1px solid #000;border-right:none;font-family:SimSun;font-size:0.6rem;text-align:left;padding-left:0.3rem;" colspan="3">
            {{reportInfo.testItems}}
          </td>
        </tr>
        <tr v-if="reportInfo.testDevices">
          <td style="border:1px solid #000;border-left:none;height:1.6rem;">
            <p style="font-size:0.6rem;font-family:KaiTi;">检测设备</p>
            <p style="font-size:0.5rem;font-family:Times New Roman;">Test devices</p>
          </td>
          <td style="border:1px solid #000;border-right:none;font-family:SimSun;font-size:0.6rem;text-align:left;padding-left:0.3rem;" colspan="3">
            {{reportInfo.testDevices}}
          </td>
        </tr>
        <tr v-if="reportInfo.testConclusion">
          <td style="border:1px solid #000;border-left:none;height:1.6rem;">
            <p style="font-size:0.6rem;font-family:KaiTi;">检测结论</p>
            <p style="font-size:0.5rem;font-family:Times New Roman;">Test conclusion</p>
          </td>
          <td style="border:1px solid #000;border-right:none;font-family:SimSun;font-size:0.6rem;text-align:left;padding-left:0.3rem;" colspan="3">
            {{reportInfo.testConclusion}}
          </td>
        </tr>
      </table>
    </div>
    <div style="text-align:justify;margin-top:0.7rem;">
      <slot></slot>
    </div>
    </div>
    <div style="border-top:1px solid #000;text-align:center;margin-top:0.7rem;" slot="signature">
      <table class="sign-table">
        <tr style="">
          <td style="width:4rem;">
            <p style="font-size:0.6rem;font-family:KaiTi;line-height:0.6rem;">批准</p>
            <p
              style="font-size:0.5rem;font-family:Times New Roman;line-height:0.6rem;height:0pt;"
            >Authorizer</p>
          </td>
          <td style="border-bottom:1px solid #000;width:98pt;"><div style="width:100%;text-align:center;margin-bottom:-8pt;"><img style="width:3rem;" :src="signature.authorizer.sUrl" /></div></td>
          <td style="width:4rem;">
            <p style="font-size:0.6rem;font-family:KaiTi;line-height:0.6rem;">审核</p>
            <p
              style="font-size:0.5rem;font-family:Times New Roman;line-height:0.6rem;height:0pt;"
            >Verifier</p>
          </td>
          <td style="border-bottom:1px solid #000;width:98pt;"><div style="width:100%;text-align:center;margin-bottom:-8pt;"><img style="width:3rem;" :src="signature.verifier.sUrl" /></div></td>
          <td style="width:4rem;">
            <p style="font-size:0.6rem;font-family:KaiTi;line-height:0.6rem;">编制或主检</p>
            <p
              style="font-size:0.5rem;font-family:Times New Roman;line-height:0.6rem;height:0pt;"
            >Inspector</p>
          </td>
          <td style="border-bottom:1px solid #000;width:98pt;"><div style="width:100%;text-align:center;margin-bottom:-8pt;"><img style="width:3rem;" :src="signature.inspector.sUrl" /></div></td>
        </tr>
        <tr style="">
          <td style="">
            <p style="font-size:0.6rem;font-family:KaiTi;line-height:14pt;">姓名</p>
            <p
              style="font-size:0.5rem;font-family:Times New Roman;line-height:0.6rem;height:0pt;"
            >Name</p>
          </td>
          <td style="border-bottom:1px solid #000;width:98pt;font-family:SimSun;font-size:11pt;padding-top:8pt;">{{signature.authorizer.sName}}</td>
          <td style="">
            <p style="font-size:0.6rem;font-family:KaiTi;line-height:14pt;">姓名</p>
            <p
              style="font-size:0.5rem;font-family:Times New Roman;line-height:0.6rem;height:0pt;"
            >Name</p>
          </td>
          <td style="border-bottom:1px solid #000;width:98pt;font-family:SimSun;font-size:11pt;padding-top:8pt;">{{signature.verifier.sName}}</td>
          <td style="">
            <p style="font-size:0.6rem;font-family:KaiTi;line-height:14pt;">姓名</p>
            <p
              style="font-size:0.5rem;font-family:Times New Roman;line-height:0.6rem;height:0pt;"
            >Name</p>
          </td>
          <td style="border-bottom:1px solid #000;width:98pt;font-family:SimSun;font-size:11pt;padding-top:8pt;">{{signature.inspector.sName}}</td>
        </tr>
        <tr style="">
          <td style="">
            <p style="font-size:0.6rem;font-family:KaiTi;line-height:14pt;">发布日期</p>
            <p
              style="font-size:0.5rem;font-family:Times New Roman;line-height:0.6rem;height:0pt;"
            >Date of Issue</p>
          </td>
          <td style="border-bottom:1px solid #000;width:98pt;font-family:SimSun;font-size:0.6rem;padding-top:8pt;">{{signature.authorizer.sDate}}</td>
          <td style="">
            <p style="font-size:0.6rem;font-family:KaiTi;line-height:14pt;">日期</p>
            <p
              style="font-size:0.5rem;font-family:Times New Roman;line-height:0.6rem;height:0pt;"
            >Date</p>
          </td>
          <td style="border-bottom:1px solid #000;width:98pt;font-family:SimSun;font-size:0.6rem;padding-top:8pt;">{{signature.verifier.sDate}}</td>
          <td style="">
            <p style="font-size:0.6rem;font-family:KaiTi;line-height:14pt;">日期</p>
            <p
              style="font-size:0.5rem;font-family:Times New Roman;line-height:0.6rem;height:0pt;"
            >Date</p>
          </td>
          <td style="border-bottom:1px solid #000;width:98pt;font-family:SimSun;font-size:0.6rem;padding-top:8pt;">{{signature.inspector.sDate}}</td>
        </tr>
      </table>
    </div>
  </normal-page>
  </div>
</template>
<script>
import normalPage from './NormalPage.vue'

export default {
  name: "signaturePage",
  components: {
      normalPage,
  },
  props: {
    reportInfo: {
      type: Object,
      default(){
        return {
          sampleName: "",
          contractNo: NaN,
          sampleAmount: "",
          report_display_no: "",
          project_display_no: "",
          testLocation: "",
          receiptDate: "",
          testDate: "",
          sampleInfo: "",
          standardList: [],
          langguage:undefined,
          totalPage: 1
      };
      }
    },
    signature: {
      type: Object,
      default(){
        return {
        inspector: {
          sDate: "",
          sName: "",
          sUrl: ""
        },
        verifier: {
          sDate: "",
          sName: "",
          sUrl: ""
        },
        authorizer: {
          sDate: "",
          sName: "",
          sUrl: ""
        },
        };
      }
    },
    reportNo:{
      type:String,
      default:''
    },
    totalPage: {
      type:Number,
      default:0
    },
    qrCodeUrl:{
      type:String,
      default:"nonValid"
    }
  },
  data() {
    return {
      currentPage:1,
      
    };
  },
  methods: { 
  },
  computed: {
  }
};
</script>
<style scoped>
div,p{
  padding: 0;
  margin:0;
}

td{
  padding: 0.1rem 0;
}

.sign-table{
  border-collapse:collapse;
  width:100%;
}

.sign-table tr{
  height:1.6rem;
}

.sign-table td{
  height:1.0rem;
}

</style>